const useListRegions = () => {
  const regions = new Map([
    ["us-east-1", "us-east-1 (N. Virginia)"],
    ["us-east-2", "us-east-2 (Ohio)"],
    ["us-west-1", "us-west-1 (N. California)"],
    ["us-west-2", "us-west-2 (Oregon)"],
    ["us-gov-west-1", "us-gov-west-1 (US-West)"],
    ["us-gov-east-1", "us-gov-east-1 (US-East)"],
    ["ap-east-1", "ap-east-1 (Hong Kong)"],
    ["ap-south-1", "ap-south-1 (Mumbai)"],
    ["ap-south-2", "ap-south-2 (Hyderabad)"],
    ["ap-northeast-3", "ap-northeast-3 (Osaka)"],
    ["ap-northeast-2", "ap-northeast-2 (Seoul)"],
    ["ap-northeast-1", "ap-northeast-1 (Tokyo)"],
    ["ap-southeast-1", "ap-southeast-1 (Singapore)"],
    ["ap-southeast-2", "ap-southeast-2 (Sydney)"],
    ["ap-southeast-3", "ap-southeast-3 (Jakarta)"],
    ["ap-southeast-4", "ap-southeast-4 (Melbourne)"],
    ["ap-southeast-5", "ap-southeast-5 (Malaysia)"],
    ["ap-southeast-7", "ap-southeast-7 (Thailand)"],
    ["ca-central-1", "ca-central-1 (Canada Central)"],
    ["ca-west-1", "ca-west-1 (Calgary)"],
    ["cn-north-1", "cn-north-1 (Beijing)"],
    ["cn-northwest-1", "cn-northwest-1 (Ningxia)"],
    ["eu-central-1", "eu-central-1 (Frankfurt)"],
    ["eu-central-2", "eu-central-2 (Zurich)"],
    ["eu-west-1", "eu-west-1 (Ireland)"],
    ["eu-west-2", "eu-west-2 (London)"],
    ["eu-west-3", "eu-west-3 (Paris)"],
    ["eu-north-1", "eu-north-1 (Stockholm)"],
    ["eu-south-1", "eu-south-1 (Milan)"],
    ["eu-south-2", "eu-south-2 (Spain)"],
    ["il-central-1", "il-central-1 (Tel Aviv)"],
    ["me-south-1", "me-south-1 (Bahrain)"],
    ["me-central-1", "me-central-1 (UAE)"],
    ["mx-central-1", "mx-central-1 (Mexico Central)"],
    ["sa-east-1", "sa-east-1 (Sao Paulo)"],
    ["af-south-1", "af-south-1 (Cape Town)"],
    ["ap-east-1", "ap-east-1 (Hong Kong)"],
  ]);
  return regions;
};

export default useListRegions;